import { useRouteError } from 'react-router-dom'

import { CustomErrorFallback } from './CustomErrorFallback'

export const ErrorBoundary = () => {
  const error = useRouteError() as { message: string; stack: string }

  return (
    <CustomErrorFallback
      error={error}
      componentStack={error.stack}
    />
  )
}
